import { Component, OnInit } from '@angular/core';
import { Field } from 'src/app/models_new/classes/field';
import { FieldType } from 'src/app/models_new/types/field-type';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-new-simple-simulation',
  templateUrl: './new-simple-simulation.component.html',
  styleUrls: ['./new-simple-simulation.component.scss'],
})
export class NewSimpleSimulationComponent implements OnInit {
  fields: Field[];
  ready = false;

  constructor(public dialogRef: MatDialogRef<NewSimpleSimulationComponent>) {}

  ngOnInit(): void {
    this.fields = [
      new Field(
        FieldType.TEXT,
        true,
        '',
        null,
        null,
        null,
        null,
        { label: 'Name', name: 'sim.name' },
        'sim_name'
      ),
    ];

    this.ready = true;
  }

  close() {
    const selected = this.fields.map((m) => ({
      name: m.id,
      value: m.formControl.value,
    }));
    this.dialogRef.close(selected);
  }
}
